<template>
    <div class="announcement-manage">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>公告管理</span>
            </div>

            <!-- 搜索区域 -->
            <div class="search-area">
                <el-input v-model="searchKeyword" placeholder="请输入序号或内容简介搜索" style="width: 300px; margin-right: 10px"
                    clearable @keyup.enter.native="handleSearch">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button @click="resetSearch">重置</el-button>

                <!-- 添加公告按钮 -->
                <el-button type="primary" @click="handleAddAnnouncement" style="margin-left: auto">
                    添加公告
                </el-button>
            </div>

            <!-- 公告表格 -->
            <el-table :data="filteredAnnouncementList" style="width: 100%; margin-top: 20px" v-loading="loading" border
                stripe>
                <el-table-column type="index" label="序号" width="60" align="center">
                    <template slot-scope="scope">
                        {{ (scope.$index + 1) }}
                    </template>
                </el-table-column>
                <el-table-column prop="serialNumber" label="排序位置" width="100" align="center">
                </el-table-column>
                <el-table-column prop="contentBrief" label="内容简介" align="center">
                </el-table-column>
                <el-table-column prop="contentDetail" label="内容详情" align="center" width="300">
                    <template slot-scope="scope">
                        <div class="content-detail-preview">
                            {{ scope.row.contentDetail ? scope.row.contentDetail.substring(0, 50) +
                                (scope.row.contentDetail.length > 50 ? '...' : '') : '' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="publishTime" label="发布时间" width="180" align="center">
                </el-table-column>
                <el-table-column prop="imageUrl" label="图片" align="center" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.imageUrl" class="image-thumbnail-container">
                            <img :src="scope.row.imageUrl" alt="图片缩略图" class="image-thumbnail"
                                @click="previewImage(scope.row.imageUrl)" />

                        </div>
                        <span v-else class="no-image">无图片</span>
                    </template>
                </el-table-column>
                <el-table-column prop="linkUrl" label="链接地址" align="center" width="200">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.linkUrl" :href="scope.row.linkUrl" target="_blank" type="primary">
                            打开链接
                        </el-link>
                        <span v-else>无</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleEdit(scope.row)">
                            编辑
                        </el-button>
                        <el-button type="danger" size="mini" @click="handleDelete(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 添加/编辑公告对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose" :close-on-click-modal="false">
            <el-form ref="announcementForm" :model="announcementForm" :rules="rules" label-width="100px">

                <el-form-item label="排序位置" prop="serialNumber">
                    <el-input v-model="announcementForm.serialNumber" placeholder="请输入序号" type="number"></el-input>
                </el-form-item>
                <el-form-item label="内容简介" prop="contentBrief">
                    <el-input v-model="announcementForm.contentBrief" placeholder="请输入内容简介"></el-input>
                </el-form-item>
                <el-form-item label="内容详情" prop="contentDetail">
                    <el-input v-model="announcementForm.contentDetail" type="textarea" :rows="4"
                        placeholder="请输入内容详情"></el-input>
                </el-form-item>
                <el-form-item label="发布时间" prop="publishTime">
                    <!-- <el-date-picker v-model="announcementForm.publishTime" type="datetime" placeholder="选择发布时间"
                        format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%">
                    </el-date-picker> -->
                    <el-input v-model="announcementForm.publishTime" placeholder="请输入发布时间，格式：yyyy-MM-dd"></el-input>
                </el-form-item>
                <el-form-item label="图片地址">
                    <div class="image-upload-container">
                        <el-input v-model="announcementForm.imageUrl" placeholder="图片地址">
                            <template slot="append">
                                <el-button @click="handleImageUpload">选择图片</el-button>
                            </template>
                        </el-input>
                        <div v-if="announcementForm.imageUrl" class="image-preview">
                            <img :src="announcementForm.imageUrl" alt="图片预览"
                                @click="previewImage(announcementForm.imageUrl)">

                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="链接地址">
                    <el-input v-model="announcementForm.linkUrl" placeholder="请输入链接地址"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitAnnouncementForm">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 图片上传对话框 -->
        <el-dialog title="上传图片" :visible.sync="imageUploadDialogVisible" width="500px" @close="handleImageDialogClose" :close-on-click-modal="false">
            <div class="upload-container">
                <el-upload class="upload-area" drag action="#" :auto-upload="false" :on-change="handleImageChange"
                    :on-remove="handleImageRemove" :file-list="imageFileList" accept="image/*"
                    :before-upload="beforeImageUpload">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">
                        支持 JPG、PNG、GIF 格式，大小不超过 5MB
                    </div>
                </el-upload>

                <div v-if="uploading" class="upload-progress">
                    <el-progress :percentage="uploadProgress" :status="uploadStatus"></el-progress>
                    <div class="progress-text">{{ uploadMessage }}</div>
                </div>

                <div v-if="previewImageUrl" class="image-preview-dialog">
                    <div class="preview-title">图片预览</div>
                    <img :src="previewImageUrl" alt="图片预览" class="preview-image">
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="imageUploadDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="uploadImage" :loading="uploading" :disabled="!imageFile">
                    上 传
                </el-button>
            </span>
        </el-dialog>

        <!-- 图片预览对话框 -->
        <el-dialog :visible.sync="previewDialogVisible" width="80%" top="5vh" :close-on-click-modal="false">
            <img :src="currentPreviewImage" alt="图片预览" style="width: 100%; max-height: 70vh; object-fit: contain;">
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'AnnouncementManage',
    data() {
        return {
            // 公告列表数据
            announcementList: [],
            // 搜索关键词
            searchKeyword: '',
            // 加载状态
            loading: false,
            // 主对话框显示状态
            dialogVisible: false,
            // 图片上传对话框显示状态
            imageUploadDialogVisible: false,
            // 图片预览对话框显示状态
            previewDialogVisible: false,
            // 是否为编辑模式
            isEditMode: false,
            // 对话框标题
            dialogTitle: '添加公告',
            // 公告表单数据
            announcementForm: {
                id: null,
                serialNumber: '',
                contentBrief: '',
                contentDetail: '',
                publishTime: '',
                imageUrl: '',
                linkUrl: ''
            },
            // 待上传的图片文件
            imageFile: null,
            // 上传文件列表
            imageFileList: [],
            // 上传中状态
            uploading: false,
            // 上传进度
            uploadProgress: 0,
            // 上传状态
            uploadStatus: '',
            // 上传消息
            uploadMessage: '',
            // 预览图片URL
            previewImageUrl: '',
            // 当前预览的图片
            currentPreviewImage: '',
            // 表单验证规则
            rules: {
                serialNumber: [
                    { required: true, message: '请输入序号', trigger: 'blur' },
                    { pattern: /^\d+$/, message: '序号必须为数字', trigger: 'blur' }
                ],
                contentBrief: [
                    { required: true, message: '请输入内容简介', trigger: 'blur' }
                ],
                contentDetail: [
                    { required: true, message: '请输入内容详情', trigger: 'blur' }
                ],
                publishTime: [
                    { required: true, message: '请输入发布时间', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        // 过滤后的公告列表
        filteredAnnouncementList() {
            if (!this.searchKeyword.trim()) {
                return this.announcementList
            }

            const keyword = this.searchKeyword.toLowerCase()
            return this.announcementList.filter(announcement =>
                (announcement.serialNumber && announcement.serialNumber.toString().toLowerCase().includes(keyword)) ||
                (announcement.contentBrief && announcement.contentBrief.toLowerCase().includes(keyword)) ||
                (announcement.contentDetail && announcement.contentDetail.toLowerCase().includes(keyword))
            )
        }
    },
    created() {
        this.fetchAnnouncementList()
    },
    methods: {
        // API调用：获取公告列表
        async fetchAnnouncementList() {
            this.loading = true
            try {
                const response = await this.$axios.get('/web/announcement/queryList')
                console.log('获取公告列表响应:', response.data)

                if (response.data.status === 200) {
                    this.announcementList = response.data.object || []
                } else {
                    this.$message.error(response.data.msg || '获取公告列表失败')
                }
            } catch (error) {
                console.error('获取公告列表失败:', error)
                this.$message.error('获取公告列表失败')
            } finally {
                this.loading = false
            }
        },

        // API调用：获取单个公告
        async getAnnouncementById(id) {
            try {
                const response = await this.$axios.get('/web/announcement/queryById', {
                    params: { id }
                })
                console.log('获取公告详情响应:', response.data)
                return response.data
            } catch (error) {
                console.error('获取公告详情失败:', error)
                throw error
            }
        },

        // API调用：创建公告
        async createAnnouncement(data) {
            try {
                const requestData = {
                    serialNumber: parseInt(data.serialNumber),
                    contentBrief: data.contentBrief,
                    contentDetail: data.contentDetail,
                    publishTime: data.publishTime,
                    imageUrl: data.imageUrl || '',
                    linkUrl: data.linkUrl || ''
                }
                console.log('创建公告请求参数:', requestData)

                const response = await this.$axios.post('/web/announcement/save', requestData)
                console.log('创建公告响应:', response.data)
                return response.data
            } catch (error) {
                console.error('创建公告失败:', error)
                throw error
            }
        },

        // API调用：更新公告
        async updateAnnouncement(data) {
            try {
                const requestData = {
                    id: data.id,
                    serialNumber: parseInt(data.serialNumber),
                    contentBrief: data.contentBrief,
                    contentDetail: data.contentDetail,
                    publishTime: data.publishTime,
                    imageUrl: data.imageUrl || '',
                    linkUrl: data.linkUrl || ''
                }
                console.log('更新公告请求参数:', requestData)

                const response = await this.$axios.put('/web/announcement/updateById', requestData)
                console.log('更新公告响应:', response.data)
                return response.data
            } catch (error) {
                console.error('更新公告失败:', error)
                throw error
            }
        },

        // API调用：删除公告
        async deleteAnnouncement(id) {
            try {
                const response = await this.$axios.delete('/web/announcement/deleteById', {
                    params: { id }
                })
                console.log('删除公告响应:', response.data)
                return response.data
            } catch (error) {
                console.error('删除公告失败:', error)
                throw error
            }
        },

        // API调用：上传图片
        async uploadImageFile(file) {
            try {
                const formData = new FormData()
                formData.append('file', file)

                // 模拟上传进度
                this.uploadProgress = 0
                const progressInterval = setInterval(() => {
                    if (this.uploadProgress < 90) {
                        this.uploadProgress += 10
                    }
                }, 200)

                const response = await this.$axios.post('/web/announcement/uploadImage', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: (progressEvent) => {
                        if (progressEvent.lengthComputable) {
                            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        }
                    }
                })

                clearInterval(progressInterval)
                this.uploadProgress = 100

                console.log('上传图片响应:', response.data)
                return response.data
            } catch (error) {
                console.error('上传图片失败:', error)
                throw error
            }
        },

        // 搜索公告
        handleSearch() {
            // 使用computed属性自动过滤，这里不需要额外处理
        },
        // 重置搜索
        resetSearch() {
            this.searchKeyword = ''
        },

        // 打开添加公告对话框
        handleAddAnnouncement() {
            this.isEditMode = false
            this.dialogTitle = '添加公告'
            this.announcementForm = {
                id: null,
                serialNumber: '',
                contentBrief: '',
                contentDetail: '',
                publishTime: this.getCurrentTime(),
                imageUrl: '',
                linkUrl: ''
            }
            this.dialogVisible = true
        },

        // 打开编辑公告对话框
        async handleEdit(announcement) {
            this.isEditMode = true
            this.dialogTitle = '编辑公告'

            try {
                const response = await this.getAnnouncementById(announcement.id)
                if (response.status === 200) {
                    this.announcementForm = {
                        id: response.object.id,
                        serialNumber: response.object.serialNumber,
                        contentBrief: response.object.contentBrief,
                        contentDetail: response.object.contentDetail,
                        publishTime: response.object.publishTime,
                        imageUrl: response.object.imageUrl || '',
                        linkUrl: response.object.linkUrl || ''
                    }
                    this.dialogVisible = true
                } else {
                    this.$message.error(response.msg || '获取公告详情失败')
                }
            } catch (error) {
                console.error('获取公告详情失败:', error)
                this.$message.error('获取公告详情失败')
            }
        },

        // 删除公告
        handleDelete(announcement) {
            this.$confirm(`确定要删除公告 "${announcement.contentBrief}" 吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const response = await this.deleteAnnouncement(announcement.id)
                    if (response.status === 200) {
                        this.$message.success('删除成功')
                        this.fetchAnnouncementList()
                    } else {
                        this.$message.error(response.msg || '删除失败')
                    }
                } catch (error) {
                    console.error('删除公告失败:', error)
                    this.$message.error('删除失败')
                }
            }).catch(() => {
                // 用户取消删除
            })
        },

        // 提交公告表单
        submitAnnouncementForm() {
            this.$refs.announcementForm.validate(async (valid) => {
                if (valid) {
                    try {
                        if (this.isEditMode) {
                            // 编辑公告
                            const response = await this.updateAnnouncement(this.announcementForm)
                            if (response.status === 200) {
                                this.$message.success('更新成功')
                                this.dialogVisible = false
                                this.fetchAnnouncementList()
                            } else {
                                this.$message.error(response.msg || '更新失败')
                            }
                        } else {
                            // 添加公告
                            const response = await this.createAnnouncement(this.announcementForm)
                            if (response.status === 200) {
                                this.$message.success('添加成功')
                                this.dialogVisible = false
                                this.fetchAnnouncementList()
                            } else {
                                this.$message.error(response.msg || '添加失败')
                            }
                        }
                    } catch (error) {
                        console.error('操作失败:', error)
                        this.$message.error('操作失败')
                    }
                }
            })
        },

        // 对话框关闭处理
        handleDialogClose() {
            this.$refs.announcementForm.resetFields()
            this.announcementForm = {
                id: null,
                serialNumber: '',
                contentBrief: '',
                contentDetail: '',
                publishTime: '',
                imageUrl: '',
                linkUrl: ''
            }
        },

        // 获取当前时间
        getCurrentTime() {
            const now = new Date()
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')
            const seconds = String(now.getSeconds()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        },

        // 打开图片上传对话框
        handleImageUpload() {
            this.imageUploadDialogVisible = true
            this.imageFile = null
            this.imageFileList = []
            this.previewImageUrl = ''
            this.uploading = false
            this.uploadProgress = 0
        },

        // 图片上传对话框关闭处理
        handleImageDialogClose() {
            this.imageFile = null
            this.imageFileList = []
            this.previewImageUrl = ''
            this.uploading = false
            this.uploadProgress = 0
        },

        // 处理图片选择
        handleImageChange(file, fileList) {
            this.imageFile = file.raw
            this.imageFileList = fileList.slice(-1) // 只保留最后一个文件

            // 生成预览URL
            if (file.raw) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.previewImageUrl = e.target.result
                }
                reader.readAsDataURL(file.raw)
            }
        },

        // 处理图片移除
        handleImageRemove() {
            this.imageFile = null
            this.imageFileList = []
            this.previewImageUrl = ''
        },

        // 图片上传前验证
        beforeImageUpload(file) {
            const isImage = file.type.startsWith('image/')
            const isLt5M = file.size / 1024 / 1024 < 5

            if (!isImage) {
                this.$message.error('只能上传图片文件！')
                return false
            }
            if (!isLt5M) {
                this.$message.error('图片大小不能超过5MB！')
                return false
            }
            return true
        },

        // 上传图片
        async uploadImage() {
            if (!this.imageFile) {
                this.$message.warning('请先选择图片')
                return
            }

            // 验证文件
            if (!this.beforeImageUpload(this.imageFile)) {
                return
            }

            this.uploading = true
            this.uploadStatus = ''
            this.uploadMessage = '正在上传...'

            try {
                const response = await this.uploadImageFile(this.imageFile)
                if (response.status === 200) {
                    this.uploadStatus = 'success'
                    this.uploadMessage = '上传成功'
                    this.$message.success('上传成功')

                    // 这里假设返回的object就是图片地址，根据实际接口调整
                    const imageUrl = response.object || ''
                    this.announcementForm.imageUrl = imageUrl

                    // 延迟关闭对话框，让用户看到上传成功
                    setTimeout(() => {
                        this.imageUploadDialogVisible = false
                    }, 1000)
                } else {
                    this.uploadStatus = 'exception'
                    this.uploadMessage = response.msg || '上传失败'
                    this.$message.error(response.msg || '上传失败')
                }
            } catch (error) {
                console.error('上传图片失败:', error)
                this.uploadStatus = 'exception'
                this.uploadMessage = '上传失败'
                this.$message.error('上传失败')
            } finally {
                this.uploading = false
            }
        },

        // 预览图片
        previewImage(imageUrl) {
            this.currentPreviewImage = imageUrl
            this.previewDialogVisible = true
        }
    }
}
</script>

<style scoped>
.announcement-manage {
    padding: 20px;
}

.box-card {
    min-height: calc(100vh - 100px);
}

.search-area {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.el-table {
    margin-top: 20px;
}

.el-button+.el-button {
    margin-left: 10px;
}

.content-detail-preview {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.image-upload-container {
    width: 100%;
}

.image-preview {
    margin-top: 10px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 10px;
    background: #f5f7fa;
}

.image-preview img {
    max-width: 100%;
    max-height: 200px;
    cursor: pointer;
    border-radius: 4px;
}

.image-preview img:hover {
    opacity: 0.8;
}


.upload-container {
    padding: 10px;
}

.upload-area {
    margin-bottom: 20px;
}

.upload-progress {
    margin: 20px 0;
}

.progress-text {
    text-align: center;
    margin-top: 5px;
    color: #606266;
    font-size: 14px;
}

.image-preview-dialog {
    margin-top: 20px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 15px;
    background: #f5f7fa;
}

.preview-title {
    font-size: 14px;
    color: #606266;
    margin-bottom: 10px;
    text-align: center;
}

.preview-image {
    max-width: 100%;
    max-height: 200px;
    display: block;
    margin: 0 auto;
    border-radius: 4px;
}

/* 新增缩略图样式 */
.image-thumbnail-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;
}

.image-thumbnail {
    width: 80px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #f5f7fa;
}

.image-thumbnail:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border-color: #409eff;
}



.no-image {
    color: #909399;
    font-size: 12px;
}

/* 调整表格行高以适应缩略图 */
.el-table .cell {
    padding: 8px 0;
}

/* 确保图片预览对话框中的图片显示正常 */
.preview-image {
    max-width: 100%;
    max-height: 200px;
    display: block;
    margin: 0 auto;
    border-radius: 4px;
}

/* 调整图片上传预览区域 */
.image-preview-dialog {
    margin-top: 20px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 15px;
    background: #f5f7fa;
    text-align: center;
}

.preview-title {
    font-size: 14px;
    color: #606266;
    margin-bottom: 10px;
    text-align: center;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
    .image-thumbnail {
        width: 60px;
        height: 45px;
    }

}
</style>